import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=6024ef3d&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=6024ef3d&lang=scss&scoped=true&"
import style1 from "./ProductList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024ef3d",
  null
  
)

export default component.exports